export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 px-6 py-8 sm:px-10 lg:px-20">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 text-xs tracking-wide text-[#6B7280] lg:flex-row lg:items-center lg:justify-between">
        <span data-testid="footer-left">
          <span className="font-serif text-[#C4A24C]">
            VoiceGuard<span className="font-bold">USB</span>™
          </span>
          {" · Patent Pending · Trademark Pending"}
        </span>
        <span data-testid="footer-right">
          Defend Trade Secrets Act, 18 U.S.C. § 1836 · Confidential
        </span>
      </div>
      <p className="mx-auto mt-4 max-w-7xl text-xs tracking-wide text-[#6B7280]">
        Application filed and held individually by Armondo L. Sullivan-Gardea. No assignment executed.
      </p>
    </footer>
  );
}
